import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { animeBackground } from '../../../../app/pages/animation';
import { UsersService } from '@app/services/users.service';
import { CommonService } from '@app/services/common.service';
import { SitesService } from '@app/services/sites.service';
import { DealerPlanService } from '@app/services/service-plan.service';
import { VideoAIService } from '@app/services/cloud-ai.service';
import { Helper } from '../../../../4services/2helper';
import { c_components } from '../..';
import { Modal } from '../../../../app/model/modal';
import ims from '../../imports'
import { lastValueFrom } from 'rxjs';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_card_site_plan_v3',
    templateUrl: './c_card_site_plan_v3.component.html',
    styleUrls: ['../common.scss', './c_card_site_plan_v3.component.scss'],
    animations: [animeBackground],
    standalone: false
})
export class c_card_site_plan_v3_component extends BaseComponent implements OnInit {
  @ViewChild('resizableDiv', { static: false }) resizableDiv!: ElementRef;
  @ViewChild('planContainer', { static: false }) planContainer!: ElementRef;
  @Input() currentDealerPlan: number;
  @Input() currentSitePlan: number;
  @Input() nextMonthSitePlan: number;
  @Input() servicePricing: any;
  @Input() isTrialPeriod: boolean = false;
  @Input() hasCHeKTBridge: boolean = false;
  @Input() hasExternalBridge: boolean = false;
  @Output() refreshSitePlan = new EventEmitter();
  me = this.usersService.me;
  site: any;
  isMainDealer = false;
  isHasEditPermission = false;
  isHasViewPricePermission = false;
  resizeObserver!: ResizeObserver;

  isLoading = false;
  isIPad: boolean = false;

  m_notice = new Modal();
  m_cloud_ai_default_settings = new Modal();
  isEnabledDealerCloudAI = false;
  isEnabledSiteCloudAI = false;
  originDetectObjectFilter = [];
  tos: any;

  constructor(
    public usersService: UsersService,
    public commonService: CommonService,
    private sitesService: SitesService,
    public dealerPlanService: DealerPlanService,
    private videoAIService: VideoAIService,
    private c_components: c_components,
    private helper: Helper,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) { super(); }

  async ngOnInit() {
    const url = window.location.href;
    const params = this.commonService.getQueryParams(url.split('?')[1]);
    let dealer_id = null;

    if (params['dealer_id']) dealer_id = params['dealer_id'];
    this.site = this.sitesService.selSite;
    this.isMainDealer = this.me().type === 2;
    this.isHasEditPermission = this.helper.permission.has('site_plan_update')
    this.isHasViewPricePermission = this.helper.permission.has('dealer_invoice_read')
    await this.getSiteCloudAIConfig();
    this.cdr.detectChanges();
  }

  
  // !!!! 이 컴포넌트는 Site에서만 사용할 것 !!! //
  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(ims._.debounce(entries => {
      requestAnimationFrame(() => {
        for (let entry of entries) {
          const width = entry.contentRect.width;
          this.isIPad = width < 930;
          const el = this.planContainer?.nativeElement;
          if (!el) continue;

          if (this.isIPad) {
            this.renderer.removeClass(el, 'plan-container');
            this.renderer.addClass(el, 'plan-container-vertical');
          } else {
            this.renderer.removeClass(el, 'plan-container-vertical');
            this.renderer.addClass(el, 'plan-container');
          }
        }
      });
    }, 100));

    if(this.resizableDiv?.nativeElement) this.resizeObserver.observe(this.resizableDiv?.nativeElement);

    // 강제 초기 실행 (현재 사이즈 체크)
    this.checkSize();
    this.cdr.detectChanges();
  }

  checkSize() {
    if (!this.resizableDiv || !this.planContainer) return;
    const width = this.resizableDiv.nativeElement.clientWidth;
    this.isIPad = width < 930;

    if (this.isIPad) {
      this.renderer.removeClass(this.planContainer.nativeElement, 'plan-container');
      this.renderer.addClass(this.planContainer.nativeElement, 'plan-container-vertical');
    } else {
      this.renderer.removeClass(this.planContainer.nativeElement, 'plan-container-vertical');
      this.renderer.addClass(this.planContainer.nativeElement, 'plan-container');
    }
  }

  canEdit() {
    if (this.hasCHeKTBridge) return true;
    if (this.hasExternalBridge) return false;
    return false;
  }
  async getSiteCloudAIConfig(){
    const dealerId = this.me().dealer_id;
    const siteId = this.site.site_id;
    try {
      const res = await lastValueFrom(this.videoAIService.getSiteCloudAIConfig(dealerId, siteId));
      const { enabled, dealer_videoai_config } = res;
      this.isEnabledDealerCloudAI = dealer_videoai_config.enabled ? true : false;
      this.tos = dealer_videoai_config.tos;
      this.originDetectObjectFilter = dealer_videoai_config.filters
      this.isEnabledSiteCloudAI = enabled ? true : false;
    } catch(err) {
      console.debug('getDealerCloudAIConfig',err)
      this.isLoading = false
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.resizeObserver?.disconnect();
  }

  // -------------------------------------------------------
  // Tooltip Style
  isShowCard = {
    1: false,
    2: false,
    3: false,
    4: false,
  }
  tooltipCard(plan) {
    this.isShowCard[plan] = true
  }
  tooltipOutCard(plan) {
    this.isShowCard[plan] = false
  }

  // -------------------------------------------------------
  // ACTIONS
  isShowUpdateButton(plan, type){
    if(this.currentSitePlan === plan && this.nextMonthSitePlan === plan) return false
    if(type === 'edit') {
      return this.isHasEditPermission && (this.currentSitePlan != plan)
    }
    if(type === 'keep')  {
      return this.isHasEditPermission && this.currentSitePlan === plan && this.nextMonthSitePlan != 2
    }
  }

  async onClickSitePlanSave(planId){
    if(this.site.dealer == this.me().dealer_id && !this.tos?.is_accepted){
      return await this.checkingAdminModal() ? null : this.showCloudAIAdminWarning();
    }

    const dealerType = this.me().type
    if(dealerType === 3) {
      this.updateForSubDealer(planId)
    } else {
      this.updateForMainAndOtherDealer(planId)
    }
  }
  
  updateForSubDealer(planId){
    let msg = `
      <p>
        Plan changes require approval from the Central Station.<br/>
        Click 'Confirm' to send your request to the Central Station. 
      </p>
    `
    if(!this.tos?.is_accepted && planId === 4) msg += `<p style="margin-top: 12px;">
      Since this is your first time enabling Cloud AI, <br/>Terms of Service agreement is also required.<br/><br/>
      Please complete it in AI Filtering settings after closing this message.
    </p>`
    this.c_components.dialog.open("warning", {
      header: `Would you like to request a plan change?`,
      contents: msg,
      submit_btn: "Confirm",
      submit_class: ["button-primary"],
      icon: 'warning',
      color: 'orange',
      submit_func: async () => {
        if(!this.tos?.is_accepted && planId === 4) return this.openCloudAITOS()
        await this.requestUpdateSitePlan(planId)
      },
    })
  }
  updateForMainAndOtherDealer(planId){
    // site plan update modal
    const isDowngrade = this.currentSitePlan > planId
    const isTrialPeriod = this.isTrialPeriod
    const sitePlanName = this.parseSitePlanName(planId)

    let message = ''
    if (!isDowngrade) {
      if(isTrialPeriod) message = `Click "Confirm" to begin your free trial of the <b>${sitePlanName}</b> plan.`
      if(!isTrialPeriod) message = `Click "Confirm" to select the <b>${sitePlanName}</b> plan.`
      if(planId === 4) message += `<br/>Once you update the plan, Cloud AI will also be activated for the site.`
    }
    if (isDowngrade) { 
      if(isTrialPeriod && planId === 1) message = `The downgrade is applied immediately, and the Trial Period ends.<br/>
        <b>Billing start immediately without a trial period.<b/>
      `
      else message = `For downgrades, the changes will take effect from next month.<br/>
      Click "Confirm" to select the <b>${sitePlanName}</b> plan.
      `
    }

    this.c_components.dialog.open("warning", {
      header: `Change Site Plan`,
      contents: `
        <p> ${message} </p>
      `,
      submit_btn: "Confirm",
      submit_class: ["button-primary"],
      icon: 'info',
      color: '#55647B',
      submit_func: async () => {
        this.isLoading = true;
        await ims.tool.sleep(500)
        await this.updateSitePlan(planId)
        if(this.currentDealerPlan === 1 && planId === 4) {
          await this.enableCloudAIForBasicWithVaultPlusAI()
          return;
        }
        if((this.currentDealerPlan === 1 && this.currentSitePlan == 4) && isDowngrade) {
          await this.disableSiteLevelCloudAIWhenVaultPlusAIDisabled()
          await this.disableCloudAIForAllSitesIfVaultPlusDisabled()
          return;
        }
        await this.refreshSitePlanData();
        this.openWarningDialog('Success', 'Site Plan has been updated successfully.', 'done', 'green');
      },
    })
  }
  async refreshSitePlanData(){
    await this.setTimeSync();
    this.refreshSitePlan.emit();
    this.isLoading = false;
  }

  getPlanStyle(plan) {
    return this.currentSitePlan === plan ? 'current' : '';
  }
  
  // ⚙️ Cloud AI 관련 Configs
  // enable logic
  async enableCloudAIForBasicWithVaultPlusAI(){
    this.isLoading = true;
    // 해당 플랜을 사용하면 Cloud AI를 사용할 수 있음.

    if(this.tos?.is_accepted || this.isEnabledDealerCloudAI) {
      // dealer도 안켜져 있을 때
      if(!this.isEnabledDealerCloudAI) await this.enableCloudDealerSettings();
      // site만 켜면 될 때 
      if(!this.isEnabledSiteCloudAI) await this.enableCloudSiteSettings();
      await this.refreshSitePlanData();
      return;
    }

    // cloud AI도 TOS 승인도 안된 경우 - 내 사이트인 경우에만 실행되어야 함.
    // 그렇지 않을때는: site plan 업그레이드만 하고, 해당 딜러에게 tos 켜라고 전달해라. 그렇지 않으면 cloud ai 사용 못한다.
    if(this.site.dealer_id == this.me().dealer_id) this.openCloudAITOS()
    else this.openCompleteSitePlanUpdating()
  }
  openCloudAITOS(){
    if(this.tos?.is_accepted) return;
    this.m_notice.data['title'] = 'AI SOFTWARE ADDENDUM';
    this.m_notice['tos'] = this.tos;
    this.m_notice['is_cloud_ai'] = true;
    this.m_notice.open();
  }
  showCloudAIAdminWarning(){
    this.c_components.dialog.open('warnong',{
      header: "Only Admins can upgrade the plan to enable Cloud AI",
      contents: `
      <p>
        Please contact an Admin user to proceed.
      </p>
      `,
      submit_btn: 'OK',
      submit_class: ["button-primary"],
      icon: 'warning',
      isConfirm: true,
      color: 'orange',
      submit_func: () => {},
    })
  }
  openCompleteSitePlanUpdating(){
    // site plan 업데이트 하긴 했는데 제대로 사용하려면 해당 딜러가 직접 Cloud AI를 켜야 해
    // 해당 딜러에게 직접 연락해봐. 
    this.c_components.dialog.open('warning', {
      header: "Site Plan upgrade is complete",
      contents: `
      <p>
        However, to activate Cloud AI on this site, the dealer must agree to the Cloud AI Terms of Service directly.<br/>
        Please make sure to inform the dealer.<br/><br/>
        To proceed with the TOS agreement, go to <b>Settings > AI Filtering</b>.
      </p>
      `,
      submit_btn: 'OK',
      submit_class: ["button-primary"],
      icon: 'warning',
      isConfirm: true,
      color: 'orange',
      submit_func: async () => await this.refreshSitePlanData(),
    })
  }
  async closedAgreementDialog(result){
    // result가 오면 tos accept 했다는 의미
    const amISubDealerUser = this.me().type === 3
    if(result && !amISubDealerUser) {
      this.m_cloud_ai_default_settings.open() // dealer default settings
    }
    if(result && amISubDealerUser){
      await this.requestUpdateSitePlan(4) // 여기 왔다면 plan id는 4
    }
    // not Accept : pass
    await this.refreshSitePlanData();
    this.isLoading = false;
  }
  async applyDealerDeafaultCloudAISettings(data){
    try {
      const amISubDealerUser = this.me().type === 3
      await this.confirmSaveDefaultSettings(data);
      if(!amISubDealerUser) await this.enableCloudDealerSettings();
      await this.enableCloudSiteSettings();
      await this.refreshSitePlanData();
      this.openMoveToSiteCloudAISettingModal();
      this.isLoading = false;
    } catch(err) {
      await this.refreshSitePlanData();
      this.isLoading = false;
      console.debug('applyDealerDeafaultCloudAISettings', err)
    }
  }
  openMoveToSiteCloudAISettingModal(){
    this.c_components.dialog.open("warning", {
      header: `Enable Cloud AI`,
      contents: `
        <p>Cloud AI has been activated. You can review the detailed settings on the following page.<br/>
        <b>'Site Details > Cloud AI Management'</b>
        </p>
      `,
      submit_btn: "Go to Settings",
      submit_class: ["button-primary"],
      icon: 'done',
      color: 'green',
      submit_func: () => {
        this.commonService.emitSiteTab([{name: 'Devices', link: 'devices/cloud-ai'}, 'cloud-ai']);
      },
    })
  }

  // disable logic
  async disableSiteLevelCloudAIWhenVaultPlusAIDisabled(){
    // 일단 현재 site plan이 video vault plus ai이고 끄려고 시도한 것.
    // 사이트 cloud ai 끄기
    if(!this.isEnabledSiteCloudAI) return;

    const siteId = this.site.site_id;
    const dealerId = this.me().dealer_id;
    const cloudAIData = { enabled : 0 }
    await lastValueFrom(this.videoAIService.updateSiteCloudAIConfig(dealerId, siteId, cloudAIData))
  }
  async disableCloudAIForAllSitesIfVaultPlusDisabled(){
    await ims.tool.sleep(500) // wait for updating
    const isVaultPlusAIDisabledForAllSites = await this.checkAllSitesVaultPlusDisabled();
    if(!isVaultPlusAIDisabledForAllSites) {
      await this.refreshSitePlanData();
      this.openWarningDialog('Success', 'Site Plan has been updated successfully.', 'done', 'green');
      return;
    }
    await this.disabledDealerLevelCloudAI();
    await this.refreshSitePlanData();
    this.openWarningDialog('Success', 'Site Plan has been updated successfully.', 'done', 'green');
  }
  async checkAllSitesVaultPlusDisabled(){
    try {
      const dealerId = this.me().dealer_id;
      const siteList = await lastValueFrom(this.sitesService.getSites(dealerId)) ?? [];
      const ownSiteList = siteList.filter(v => v.dealer_id === dealerId)
  
      const list = await this.helper.dealer.get_dealer_site_plans();
      const ownSitePlanList = list?.filter(el => ownSiteList.find(v => el.dealer_id === v.dealer_id)) ?? []
      
      return ownSitePlanList?.every(v => v.current_site_plan_id < 4) ? true : false;
    } catch(err) {
      console.debug('checkAllSitesVaultPlusDisabled:>',err)
      return false;
    }
  }

  // ------------------------------------------
  // Plan Update Actions
  async requestUpdateSitePlan(planId){
    try {
      this.isLoading = true;
      await this.helper.sites.request_site_plan_update(this.site.site_id, { site_plan_id: planId });
      this.openWarningDialog('Success', 'Site Plan has been requested successfully.', 'done', 'green');
      this.refreshSitePlan.emit();
      this.isLoading = false;
    } catch(err) {
      console.debug('onClickSitePlanSave :>',err)
      this.isLoading = false;
    }
  }
  async updateSitePlan(planId){
    try {
      await this.helper.sites.update_site_plan(this.site.site_id, { site_plan_id: planId });
    } catch(err) {
      console.debug('onClickSitePlanSave :>',err)
      this.isLoading = false;
    }
  }
  async updateAllCamerasTimeSync(){
    const data = { is_time_sync_enabled: 1 }
    this.isLoading = true

    const dealerId = this.me().dealer_id
    const siteId = this.site.site_id
    try {
      await lastValueFrom(this.sitesService.updateDevices(dealerId, siteId, data))
    } catch(err) {
      this.isLoading = false;
      console.debug('updateAllCamerasTimeSync:>',err)
    }
    this.isLoading = false;
  }

  async setTimeSync(){
    const siteDevices = this.sitesService.siteDevices
    const cameras = siteDevices.filter(device => device.type === 12 && !device?.external_device_id)
    const isAllEnabledTimeSync = cameras.every(camera => camera.is_time_sync_enabled === 1)
    if(isAllEnabledTimeSync) return;
    await this.updateAllCamerasTimeSync()
  }
  async checkingAdminModal(){
    const roleList = await this.helper.dealer_role.get_roles() ?? []
    const myRole = roleList?.find(v => v.role_id === this.me().role_id)
    return myRole?.is_admin_role ? true : false;
  }

  // ----------------------------------------------------
  // Cloud AI Settings
  async enableCloudDealerSettings(){
    try {
      const dealerId = this.me().dealer_id
      if(this.site.daeler_id != this.me().dealer_id) {
        const cloudAIEnabledData = {
          partner_id: this.site.dealer_id,
          enabled : 1,
          videoai_provider_id: 1
        }
        await lastValueFrom(this.videoAIService.updateSubDealerCloudAIConfig(dealerId, cloudAIEnabledData))
      } else {
        const data = { enabled: 1 }
        await lastValueFrom(this.videoAIService.updateDealerCloudAIConfig(dealerId, data))
      }
    } catch(err) {
      this.isLoading = false;
      console.debug('enableCloudDealerSettings', err)
    }
  }
  async disabledDealerLevelCloudAI(){
    try {
      const dealerId = this.me().dealer_id
      if(this.site.dealer_id != this.me().dealer_id) {
        const cloudAIEnabledData = {
          partner_id: this.site.dealer_id,
          enabled: 0,
        }
        await lastValueFrom(this.videoAIService.updateSubDealerCloudAIConfig(dealerId, cloudAIEnabledData))
      } else {
        const data = { enabled: 0 }
        await lastValueFrom(this.videoAIService.updateDealerCloudAIConfig(dealerId, data))
      }
    } catch(err) {
      this.isLoading = false;
      console.debug('enableCloudDealerSettings', err)
    }
  }
  async enableCloudSiteSettings(){
    try {
      const dealerId = this.me().dealer_id
      const siteId = this.site.site_id;
      const isMySite = this.site.dealer_id == dealerId;
      const data = {
        enabled : 1,
        actions: {
          is_devices_videoai_config_reset: isMySite ? 0 : 2, // 0: no action, 1: 모두 꺼짐, 2: 딜러를 따름
          is_devices_videoai_filter_reset: isMySite ? 0 : 2 // 0: no action, 1: 모두 꺼짐, 2: 딜러를 따름
        }
      }
      await lastValueFrom(this.videoAIService.updateSiteCloudAIConfig(dealerId, siteId, data))
    } catch(err) {
      this.isLoading = false;
      console.debug('enableCloudSiteSettings', err)
    }
  }
  async confirmSaveDefaultSettings(input){
    const dealerId = this.me().dealer_id
    const {
      selectedDefaultProvider, isEnabledSuppressAlarmSignals, isEnabledSuppressNotification, isEnabledDisarmedEventAnalysis,
      selectedDetectingObjectOfPerson, selectedDetectingObjectOfVehicle
    } = input
    const data = {
      videoai_provider_id: selectedDefaultProvider.id,
      alarm_signal_suppression_enabled_site_default: isEnabledSuppressAlarmSignals ? 1 : 0,
      mobile_app_notification_suppression_enabled_site_default: isEnabledSuppressNotification ? 1 : 0,
      disarmed_event_enabled_site_default: isEnabledDisarmedEventAnalysis ? 1 : 0,
    }
    try {
      await Promise.all([
        lastValueFrom(this.videoAIService.updateDealerCloudAIConfig(dealerId, data)),
        this.updateFilterConfig(selectedDetectingObjectOfPerson, selectedDetectingObjectOfVehicle)
      ])
      this.isLoading = false
    } catch(err) {
      this.isLoading = false
      this.commonService.showErrorToast(err, 'Update Dealer Config', 'Failed');
      console.debug('confirmSaveDefaultSettings:>', err)
    }
  }

  async updateFilterConfig(selectedDetectingObjectOfPerson, selectedDetectingObjectOfVehicle){
    const personNewFilter = parseInt(selectedDetectingObjectOfPerson?.id ?? 0)
    const vehicleNewFilter = parseInt(selectedDetectingObjectOfVehicle?.id ?? 0)

    const promise = this.originDetectObjectFilter.map(filter => this.deleteDealerCloudAIFilter(filter.id))
    Promise.all(promise)
    Promise.all([
      this.createDealerCloudAIFilter(personNewFilter),
      this.createDealerCloudAIFilter(vehicleNewFilter),
    ])
  }
  async createDealerCloudAIFilter(filterId){
    if(!filterId) return
    const dealerId = this.me().dealer_id
    const data = { videoai_filter_id : filterId }
    try {
      await lastValueFrom(this.videoAIService.createDealerCloudAIFilter(dealerId, data))
    } catch(err) {
      console.debug('createDealerCloudAIFilter err:>', err)
      this.isLoading = false
      this.commonService.showErrorToast(err, `Failed Create filter - ${filterId}`, 'Failed')
    }
  }
  async deleteDealerCloudAIFilter(filterId) {
    if(!filterId) return
    const dealerId = this.me().dealer_id
    try {
      await lastValueFrom(this.videoAIService.deleteDealerCloudAIFilter(dealerId, filterId))
    } catch(err) {
      console.debug('deleteDealerCloudAIFilter err:>', err)
      this.isLoading = false
      this.commonService.showErrorToast(err, `Failed Delete filter - ${filterId}`, 'Failed')
    }
  }


  ///////////////////////////////////
  // TOOL
  parseDealerPlanNames(){
    if(this.me().type === 2) return 'Reseller'
    return 'Professional or Premium'
  }

  parseSitePlanName(planId){
    switch(planId) {
      case 1: return 'Basic';
      case 2: return 'Video Vault';
      case 3: return 'Video Vault Plus';
      case 4: return 'Video Vault Plus AI';
      default: return 'Basic';
    }
  }

  goToSitePlanPage(){
    this.helper.router.navigate_to('/settings/site-plan')
  }

  openWarningDialog(header, msg, icon, color) {
    this.c_components.dialog.open("warning", {
      header: `${header}`,
      contents: `
        <p>${msg}</b></p>
      `,
      submit_btn: "OK",
      submit_class: ["button-primary"],
      icon: icon,
      isConfirm: true,
      color: color,
      submit_func: () => {},
    });
  }
}
